import { useEffect } from 'react';

const SITE = 'https://aicostr.com';

interface SeoOptions {
  /** Document title (also the SERP title for this route). */
  title: string;
  /** Meta description for this route. */
  description?: string;
  /** Canonical path ('/demo') or absolute URL. Defaults to no change. */
  canonicalPath?: string;
}

function upsertMeta(name: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Per-route SEO for the SPA: sets the document title, meta description, and
 * canonical link when a route mounts. The static defaults in index.html cover
 * the homepage and any non-JS crawler; this refines the JS-rendered routes.
 */
export function useSeo({ title, description, canonicalPath }: SeoOptions): void {
  useEffect(() => {
    document.title = title;
    if (description) upsertMeta('description', description);
    if (canonicalPath) {
      upsertCanonical(
        canonicalPath.startsWith('http') ? canonicalPath : `${SITE}${canonicalPath}`,
      );
    }
  }, [title, description, canonicalPath]);
}
